<mat-card class="mat-elevation-z14">
  <mat-nav-list>
    <ng-container *ngFor="let w of workflows; last as last">
      <mat-list-item
        [routerLink]="[_link]"
        queryParamsHandling="preserve"
        (click)="setWorkflowId(w.id)"
      >
        {{ w.name }}
      </mat-list-item>
      <mat-divider inset *ngIf="!last"></mat-divider>
    </ng-container>
  </mat-nav-list>
</mat-card>
